import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ArrowUpIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "arrow-up",
  "ArrowUpIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M4.6665 6.66667L7.99984 2L11.3332 6.66667H8.6665V14H7.33317V6.66667H4.6665Z" fill={colorList[0]}/></g></svg>
);

export default ArrowUpIcon;
